export enum BASE_COLOR {
    PRIMARY = '#0B7D75',
    WHITE = '#FFFFFF',
    DARK = 'black',
    CONTAINER = '#FAF9F5'
}
